import { render, staticRenderFns } from "./private-research-handbook.vue?vue&type=template&id=0e3bf6fd&scoped=true&"
import script from "./private-research-handbook.vue?vue&type=script&lang=js&"
export * from "./private-research-handbook.vue?vue&type=script&lang=js&"
import style0 from "./private-research-handbook.scss?vue&type=style&index=0&id=0e3bf6fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3bf6fd",
  null
  
)

export default component.exports